import { useMutation } from "react-query";
import { EditExpenseAccount } from "../../../../../actions/Utilities/VendorConfiguration";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  editStateExpenseAccount,
  expenseAccountReFetching,
} from "../atoms/atoms";
import { IExpenseAccount } from "../type";
import { toast } from "components/toastNotification";

const useEditExpenseAccount = () => {
  
  const setActionEditState = useSetRecoilState(editStateExpenseAccount);
  const [isReFetching, setIsReFetching] = useRecoilState(
    expenseAccountReFetching
  );

  const { mutate } = useMutation(
    (newData: IExpenseAccount) => EditExpenseAccount(newData),
    {
      onSuccess: (res) => {

        if (typeof res == "object") {
          toast.fire(
            "Updating Expense Account failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Expense Account Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Expense Account Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Expense Account failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Expense Account failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Expense Account failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire(
                "Updating Expense Account failed",
                `${res}`,
                "error"
              );
          }
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update Expense Account failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};

export default useEditExpenseAccount;
